module.exports = __webpack_public_path__ + "img/bg-image-3.7de0db87.png";